export default __webpack_public_path__ + "ee139a23922b3fff884a2f59231f2e71.png";